var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
import { TransportError } from './framework/Transport';
export class AveoUniversalApiV1 {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        // other class properties and constructor
        this.pollIndex = 0;
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        this.validOutputs = []; // not all devices will have all outputs
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`ROUTE? ${key}`, /ROUTE\s+(\d+)\s+\d+|Error/i, tags);
                return match[1] ? match[1] : this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`ROUTE ${value} ${key}`, /ROUTE\s+(\d+)\s+\d+\s*(?:OK)?|Error/i, tags);
                if (match[1]) {
                    this.state.busy.update(true);
                    this.busyTimeout.set(() => this.state.busy.update(false), 1000);
                }
                return match[1] ? match[1] : this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: {
                regExp: /ROUTE\s+(\d+)\s+(\d+)/i,
                callback: (match) => {
                    const key = match[2];
                    const value = match[1];
                    this.state.videoMatrixRoutes.update(key, value);
                },
            },
        };
        // polling
        this.polls = [
            {
                intervalMs: 5000,
                // Use a polling function to only poll valid outputs for the device instead of
                // all 16 outputs are part of the static equipment configuration.
                function: () => __awaiter(this, void 0, void 0, function* () {
                    if (this.pollIndex >= this.validOutputs.length)
                        this.pollIndex = 0;
                    const key = this.validOutputs[this.pollIndex];
                    if (key) {
                        const match = yield this.socket.send(`ROUTE? ${key}`, /ROUTE\s+(\d+)\s+(\d+)|Error/i, ['poll']);
                        if (match[1])
                            this.state.videoMatrixRoutes.update(match[2], match[1]);
                    }
                    this.pollIndex++;
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.pollIndex = 0;
            this.validOutputs.length = 0; // clear array
            // Detect the valid outputs that were implemented in the Crestron device
            for (const vidOut of Object.values((_a = config.videoOutputs) !== null && _a !== void 0 ? _a : {})) {
                yield this.timeouts.delay(500); // slow down sequential queries to Crestron code
                try {
                    const key = vidOut.code;
                    const match = yield this.socket.send(`ROUTE? ${key}`, /ROUTE\s+(\d+)\s+\d+|Error/i, ['configure'], { sendTimeoutMs: 1000 } // set short to minimize delay when discovering channels
                    );
                    if (match[1])
                        this.validOutputs.push(key);
                }
                catch (error) {
                    if (!(error instanceof TransportError)) {
                        this.log.error(error);
                    }
                }
            }
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, [
                {
                    errorCode: 'verifyFailed',
                    send: 'ROUTE? 1',
                    next: /ROUTE\s+\d+\s+\d+|Error/i,
                },
            ], credentials);
        });
    }
}
// static properties
AveoUniversalApiV1.driverType = 'socketDriver';
AveoUniversalApiV1.key = '-NNsGGfeOj_5Nog4eMf2';
AveoUniversalApiV1.socketOptions = [
    {
        commandExtractor: {
            terminators: ['\r'],
        },
        port: 5000,
        sendTerminator: '\r',
    },
];
